import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NewRegistrationExistsPage} from './new-registration-exists';

import {BrMaskerModule} from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    NewRegistrationExistsPage,
  ],
  imports: [
    IonicPageModule.forChild(NewRegistrationExistsPage),
    BrMaskerModule,
  ],
  exports: [
    NewRegistrationExistsPage
  ]
})
export class NewRegistrationExistsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/new-registration-exists/new-registration-exists.module.ts